<template>
    <div class="user-home-page dashboard-page" :class="!isSuperAdmin ? 'adjust-apps-container' : ''">
        <header4IQ v-if="isSuperAdmin" :fromapp="'ug'" :pagename="'docs'"></header4IQ>
        <headerNew v-else :fromapp="'ug'" activeApp="docs" :pagename="'docs'"></headerNew>
        
        <main class="main-container">
            <section class="container-head">
                <div class="head-info">
                    <h5 class="container-title"> Application - Documents</h5>
                </div>
            </section>
            <br/>
            <section class="apps">
                <v-container fluid grid-list-lg >
                    <v-layout row wrap>
                        <v-flex lg3 v-for="(doc, index) in totalDocs" :key="index">
                            <v-card id="docsCard" class="apps_card-container">
                                <v-layout>
                                    <v-flex xs4 class = "apps_company-logo-1" overflow-hidden>
                                        <div class="name-logo-1">{{doc | logoName}}</div>
                                    </v-flex>
                                        <v-flex  xs8 class = "apps_company-info" overflow-hidden>
                                            <v-card-text>
                                                <div class="apps_info_body">
                                                    <h6 class="apps_company-name" v-text="doc+ ' Docs '"></h6>
                                                    <span class="apps_company-service" v-text="doc"></span>
                                                    <span class="apps_company-username">App help documentation</span>
                                                </div>
                                            </v-card-text>
                                    </v-flex>
                                </v-layout>
                                <v-divider class="purple"></v-divider>
                                <v-card-actions class="pa-3">
                                <h2 class="apps_company-name" v-text="doc+ ' Docs '"></h2> 
                                    <v-spacer></v-spacer>
                                    <v-icon id="launchDoc" @click="launchAppDoc(doc, key)">open_in_new</v-icon>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </section>
        </main>

    </div>
</template>

<script>
import Vue from 'vue';
import { mixin as clickaway } from 'vue-clickaway';
import header4IQ from '../../../common/components/header.vue';
import headerNew from '../../../common/components/header-new.vue';
import { mapState, mapActions } from 'vuex';

export default {
    name: 'Docs-Component',
    data () {
        return {
            docname: 'all',
            isSuperAdmin: null
        }
    },
    components: {
        header4IQ,
        headerNew
    },
    mounted() {
        document.getElementById("app-loading-4iq").style.display = "none";
    },
    created(){
        this.docname = this.$route.params['appname'];
        if(this.docname != 'all'){
            window.open('/documentation/'+this.docname+'/index.html');
        }
        if (this.loggedInUserInformation) {
            this.initializeDocsPageData();
        } else {
            this.initializeData({});
        }  
    },
    watch: {
        loggedInUserInformation() {
            this.initializeDocsPageData();
        }
    },
    computed:{
        ...mapState({
            loggedInUserInformation: state => state.loginDetails.loggedInUserInformation,
        }),
        totalDocs() {
            return this.loggedInUserInformation ? this.loggedInUserInformation['docs_information'] : [];
        }
    },
    methods: {
        ...mapActions({
            initializeData: 'loginDetails/initializeData',
        }),
        launchAppDoc(docname, key){
            window.open('/documentation/'+docname+'/index.html', "_blank");
        },
        initializeDocsPageData() {
            this.isSuperAdmin = this.loggedInUserInformation['is_superadmin'];
        }
    },
    filters: {
        logoName(name){
            if(name.length <=3){
                return name;
            }else{
                let aname = name.split(' '), lname = '';
                for (let i = 0; i < aname.length; i++) {
                    lname = lname + aname[i][0];
                }
                return lname.substring(0,3);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.adjust-apps-container {
    padding-left: 3%;
}
</style>
